



























export default {
    name: 'TextSection',

    data: -> fields: @defaultFields()

    computed:
        isDark: -> @$parent.isDark
        textAlignClass: ->
            'uk-text-left': @fields.text_align is 'links'
            'uk-text-center': @fields.text_align is 'zentriert' or @fields.text_align is 'standard'
            'uk-text-right': @fields.text_align is 'rechts'
        columns: -> @fields.columns

    methods:
        defaultFields: ->
            columns: 1
            title: []
            subtitle: []
            text: []
            button_title: [],
            button_link: []
            text_align: []
        
        setContent: (document) ->
            fields =
                columns: document.primary.columns
                title: document.primary.title
                subtitle: document.primary.subtitle
                text: document.primary.text
                button_title: document.primary.button_title
                button_link: document.primary.button_link
                text_align: document.primary.text_align
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document
}
